<div class="row justify-content-between my-3">
    <div class="headline-6 px-3">Pending</div>
    <div class="d-flex flex-row">
        @if (showBulkCheckout) {
            <button (click)="openBulkCheckoutModal()" class="btn btn--paybee btn--outline-transparent btn--padding10x15 button btn--solid-border waves-effect waves-light m-0 mr-2">
                <img src="images/payment-cards/bulkcheckout.png" class="mr-1" style="width: 15px; height: 16px;">
                Bulk Checkout...
            </button>
        }
        <div (click)="onClickAddPending()" class="btn btn--paybee btn--outline-transparent btn--padding10x15 button btn--solid-border waves-effect waves-light my-0 ml-0 mr-2 shadow-none">
            <div class="d-flex align-items-center justify-content-center">
                <svg class="mr-2" width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0)">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M21.501 13.4966L21.0197 16.1437C20.8963 16.8225 20.5224 17.4021 20.0038 17.7941C21.0279 18.3557 21.7222 19.444 21.7222 20.6944C21.7222 22.52 20.2423 24 18.4167 24C16.5911 24 15.1111 22.52 15.1111 20.6944C15.1111 19.7695 15.491 18.9333 16.1033 18.3333H11.2856C11.8979 18.9333 12.2778 19.7695 12.2778 20.6944C12.2778 22.52 10.7978 24 8.97222 24C7.14661 24 5.66667 22.52 5.66667 20.6944C5.66667 19.4968 6.30351 18.448 7.25701 17.8681C6.80672 17.5603 6.45099 17.1149 6.25575 16.578L3.7305 9.63352C3.51827 9.04987 3.52231 8.45499 3.69132 7.92215C3.56477 7.93686 3.43605 7.94442 3.30555 7.94442C1.47995 7.94442 0 6.46448 0 4.63887C0 2.81326 1.47995 1.33331 3.30555 1.33331C5.13116 1.33331 6.61111 2.81326 6.61111 4.63887C6.61111 5.14584 6.49698 5.62616 6.29301 6.05553H9.35629C9.34106 6.25723 9.3333 6.46102 9.3333 6.66662C9.3333 7.10153 9.368 7.52834 9.4348 7.94442H8.93338C7.08281 7.94442 5.79485 9.78325 6.42727 11.5224L7.57878 14.6891C7.962 15.7429 8.96355 16.4444 10.0849 16.4444H16.8196C18.061 16.4444 19.1312 15.5893 19.4143 14.3933C20.1583 14.1934 20.8594 13.8889 21.501 13.4966ZM1.88889 4.63887C1.88889 3.85646 2.52315 3.2222 3.30555 3.2222C4.08796 3.2222 4.72222 3.85646 4.72222 4.63887C4.72222 5.42127 4.08796 6.05553 3.30555 6.05553C2.52315 6.05553 1.88889 5.42127 1.88889 4.63887ZM7.55555 20.6944C7.55555 19.912 8.18982 19.2778 8.97222 19.2778C9.75462 19.2778 10.3889 19.912 10.3889 20.6944C10.3889 21.4768 9.75462 22.1111 8.97222 22.1111C8.18982 22.1111 7.55555 21.4768 7.55555 20.6944ZM18.4167 19.2778C17.6343 19.2778 17 19.912 17 20.6944C17 21.4768 17.6343 22.1111 18.4167 22.1111C19.1991 22.1111 19.8333 21.4768 19.8333 20.6944C19.8333 19.912 19.1991 19.2778 18.4167 19.2778Z" fill="#4D4D4D"></path>
                        <line x1="17.3333" y1="3.99996" x2="17.3333" y2="12" stroke="#4D4D4D" stroke-width="2.66667" stroke-linecap="round"></line>
                        <line x1="21.3334" y1="7.99996" x2="13.3334" y2="7.99996" stroke="#4D4D4D" stroke-width="2.66667" stroke-linecap="round"></line>
                    </g>
                    <defs>
                        <clipPath id="clip0">
                            <rect width="24" height="24" fill="white"></rect>
                        </clipPath>
                    </defs>
                </svg>
                <span class="text-truncate cursor-pointer">Add to Cart</span>
            </div>
            <div class="report-section__content d-none">Add pending pledge by Campaign.</div>
        </div>
    </div>
</div>
@if(!pendingDonations || pendingDonations.length === 0){
    <div class="text-center p-4">No pending donations yet.</div>
} @else{
    <div class="table--paybee">
        <table class="table" style="background-color: white; width: 100%;" 
            cellspacing="0" datatable  #auctionPendingDatatable id="auctionPendingDatatable" [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
            <thead class="thead-light">
            <tr>
                <th>Name</th>
                <th>Email</th>
                <th class="text-nowrap">First Name</th>
                <th class="text-nowrap">Last Name</th>
                <th>Phone</th>
                <th>Address</th>
                <th>Option </th>
                <th>Status</th>
                <th>Amount</th>
                <th>Value</th>
                <th>Date </th>
                <th>
                    <div class="d-flex align-items-center">
                        Info
                        <span data-toggle='popover-hover-table'
                            data-trigger='hover'
                            data-placement='right'
                            title='{{auction?.additionalInfoDesc}}'
                            class='ml-1'>
                            <i class='blue-text far fa-question-circle'  aria-hidden='true'></i>
                        </span>
                    </div>
                </th>
                <th class="text-nowrap">
                    <div class="d-flex align-items-center text-nowrap">
                        Info Selected
                        <span data-toggle='popover-hover-table'
                            data-trigger='hover'
                            data-placement='right'
                            title='{{auction?.additionalInfoSelectDesc}}'
                            class='ml-1'>
                            <i class='blue-text far fa-question-circle'  aria-hidden='true'></i>
                        </span>
                    </div>
                </th>
                <th class="no-export">Action</th>
            </tr>
            </thead>
        </table>
    </div>
    
}


